import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import app from './firebase';

const storage = getStorage(app);

export async function resolveImageUrl(opt) {
  if (!opt) {
    console.debug('resolveImageUrl: опция пуста');
    return null;
  }

  // Если уже есть готовый публичный URL
  if (opt.photo_firebase_uri && typeof opt.photo_firebase_uri === 'string') {
    console.debug('resolveImageUrl: использую photo_firebase_uri', opt.photo_firebase_uri);
    return opt.photo_firebase_uri;
  }
  if (opt.photo && typeof opt.photo === 'string' && opt.photo.startsWith('http')) {
    console.debug('resolveImageUrl: использую public photo URL', opt.photo);
    return opt.photo;
  }

  // Если есть путь в storage
  const path = opt.photo_storage_path || opt.photo_path || opt.photo_storage || null;
  if (path) {
    try {
      console.debug('resolveImageUrl: пытаюсь получить download URL для storage path', path);
      const url = await getDownloadURL(ref(storage, path));
      console.debug('resolveImageUrl: получен download URL', url);
      return url;
    } catch (e) {
      console.warn('resolveImageUrl: Не удалось получить download URL для', path, e && e.message ? e.message : e);
      return null;
    }
  }

  // Если есть поле photo, возможно это telegram file_id или base64 — фронт не справится с этим
  if (opt.photo) {
    console.debug('resolveImageUrl: поле photo присутствует, но не является URL или storage path', opt.photo.slice ? opt.photo.slice(0, 80) : opt.photo);
  }

  // Ничего не подошло
  return null;
}

export default resolveImageUrl;
